import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import '@/utils/plugins'
import '@/service-worker-register'
import App from '@/resources/views/layouts/App.vue'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')